import { render, staticRenderFns } from "./CostPivotOptionV1.vue?vue&type=template&id=6d037f0a"
import script from "./CostPivotOptionV1.vue?vue&type=script&lang=js"
export * from "./CostPivotOptionV1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports